





































































































































































































import mixins from '@/utils/mixins';
import Proxyable from '@/mixins/proxyable';
import Colorable from '@/mixins/colorable';

//models
import {
  Computation,
  NewChoice,
  NewRule,
  RuleGroup,
  SubRule
} from '@/models/configurator/question';
import { Module } from '@/models/configurator/module';

//helpers
import { mapActions } from 'vuex';
import { get } from 'vuex-pathify';
import { cloneDeep, isNil } from 'lodash';

export default mixins(Proxyable, Colorable).extend({
  name: 'ConfiguratorChoiceCard',

  props: {
    itemRequired: {
      type: Boolean,
      default: false
    },
    moduleId: {
      type: [Number, String],
      default: null
    },
    computeQuantity: {
      type: Boolean
    },
    isNumeric: {
      type: Boolean
    }
  },

  data: () => ({
    showNote: false,
    showRule: false,
    showComputation: false,
    proxyComputation: new Computation()
  }),

  computed: {
    modules: get<Module[]>('configuratorModule/modules'),
    questions: get<Module[]>('configuratorQuestion/questions')
  },

  watch: {
    // todo look into watcher
    itemRequired(value) {
      if (value) {
        if (!this.internalValue.quantity) {
          this.internalValue.quantity = 1;
        }
      }
    },
    'internalValue.computation': {
      handler(value) {
        if (value) {
          this.proxyComputation = cloneDeep(value);
        }
      },
      deep: true
    }
  },

  mounted() {
    if (this.internalValue.computation) {
      this.proxyComputation = cloneDeep(this.internalValue.computation);
    }
  },

  methods: {
    ...mapActions('configuratorQuestion', ['fetchQuestions']),

    removeChoice() {
      this.$emit('removeChoice', this.internalValue);
      this.$emit('updateValue');
    },

    toggleShowComputation() {
      if (!this.internalValue.computation) {
        this.internalValue.computation = new Computation();
      }
      this.showComputation = !this.showComputation;
    },

    setComputation() {
      this.internalValue.computation = cloneDeep(this.proxyComputation);
      this.$emit('updateValue');
    },

    toggleShowRule(choice: NewChoice) {
      // updated by reference
      if (choice.rule == null) {
        this.internalValue.rule = new NewRule();
        this.addRuleGroup();
        this.addSubRule(0);
      } else if (choice.rule && !choice.rule?.rule_groups?.length) {
        this.addRuleGroup();
        this.addSubRule(0);
      }

      this.showRule = !this.showRule;
    },

    addSubRule(groupIndex: number) {
      this.internalValue.rule.rule_groups[groupIndex].sub_rules.push(
        new SubRule({
          module: Number(this.moduleId)
        })
      );
    },

    removeRule(groupIndex: number, ruleIndex: number) {
      this.$emit('subRuleRemoved', { groupIndex, ruleIndex });
    },

    addRuleGroup() {
      this.internalValue.rule.rule_groups.push(new RuleGroup());
    },

    removeRuleGroup(groupIndex: number) {
      this.internalValue.rule.rule_groups.splice(groupIndex, 1);
      if (!this.internalValue.rule.rule_groups.length) {
        this.showRule = false;
        this.internalValue.rule = null;
        this.$emit('updateValue');
      }
      this.$forceUpdate();
    },

    tryAddRuleGroup(groupIndex: number) {
      this.addRuleGroup();
      this.addSubRule(groupIndex + 1);
      this.$forceUpdate();
    },

    subRuleAnswered() {
      this.$emit('subRuleAnswered');
    },

    newRuleEnabled(index: number) {
      return this.internalValue.rule.rule_groups[
        index
      ].sub_rules.every((rule: any) => isNil(rule.choice));
    }
  }
});
